import {
    apiRequest,
    PNSuploadSKPNS,
    PNSdetailPNS,
} from "../../../../../services/adapters/kepegawaian/PNSService"

class DetailRepository {

    fetchUploadSk = async (query) => {
        return await apiRequest("post", PNSuploadSKPNS, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", PNSdetailPNS, {
            params: query
        }, true)
    }
}

export default DetailRepository